<div class="tabs">
    <div class="tab" *ngIf="popupTool">
        <button (click)="tabs.active ='popups'" [ngClass]="{'active':tabs.active === 'popups'}">Popups</button>
    </div>
    <div class="tab" *ngIf="comparatorTool">
        <button (click)="tabs.active ='comparator'" [ngClass]="{'active':tabs.active === 'comparator'}">Comaparador</button>
    </div>
</div>
<div class="tabs-content">
    <app-sbeditor-tool-popups *ngIf="popupTool" [hidden]="tabs.active !== 'popups'" #popups></app-sbeditor-tool-popups>
    <app-sbeditor-tool-comparator *ngIf="comparatorTool" [hidden]="tabs.active !== 'comparator'" #comparator></app-sbeditor-tool-comparator>
</div>
<div class="tabs-bottom">
    <button class="btn-secondary-action m-auto" (click)="apply()">Aplicar cambios</button>
</div>